import { createI18n } from 'vue-i18n'
import fr from './locales/fr.json'
import ht from './locales/ht.json'
import en from './locales/en.json'
import es from './locales/es.json'

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('lang') || 'en', // langue par défaut
    fallbackLocale: 'fr',
    messages: { fr, ht, en, es },
    silentFallbackWarn: true,  // 🔥 supprime le warning
      silentTranslationWarn: true,
})

export default i18n